import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DISMISS_KEY = 'safaqat24.stickyCtaDismissed';

/**
 * Mobile-only sticky bottom CTA — the one action a phone visitor came for
 * (start a search). Dismissible for the session; hidden entirely on >= sm
 * screens where the hero search is always in reach. Safe-area aware.
 */
export default function StickyMobileCta() {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* storage blocked — dismiss for this render only */
    }
  };

  return (
    <div
      dir={i18n.dir()}
      className="fixed inset-x-0 bottom-0 z-40 flex items-center gap-2 border-t border-[var(--pv-border-soft)] bg-white px-4 pt-2.5 sm:hidden"
      style={{ paddingBottom: 'calc(0.625rem + env(safe-area-inset-bottom))' }}
    >
      <Link
        to="/search"
        className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-[#004D40] hover:bg-[#003930] transition-colors py-3 text-sm font-bold text-white shadow-brand-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#004D40]/20"
      >
        <i className="ri-search-2-line text-base" aria-hidden="true"></i>
        {isRTL ? 'ابحث عن عقار' : 'Find a property'}
      </Link>
      <button
        type="button"
        onClick={dismiss}
        aria-label={isRTL ? 'إخفاء الشريط' : 'Dismiss'}
        className="grid h-10 w-10 shrink-0 place-items-center rounded-xl border border-[var(--pv-border-soft)] bg-white text-[var(--pv-color-text-muted)] transition-colors hover:text-[#004D40] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#004D40]/20"
      >
        <i className="ri-close-line text-lg" aria-hidden="true"></i>
      </button>
    </div>
  );
}
